import { ShieldCheck, Star, Lock, Phone, Mail, CheckCircle2 } from "lucide-react";

// iter103 — Compact horizontal trust bar shown at the bottom of booking /
// estimate / quote flows to reinforce legitimacy right where hesitation
// happens. Renders inline (no fixed positioning) so it flows with the
// page.
export default function TrustSignalsBar({ className = "" }) {
  return (
    <section
      className={`w-full border-t border-gray-200 bg-gray-50/60 mt-10 ${className}`}
      data-testid="trust-signals-bar"
      aria-label="Trust and safety signals"
    >
      <div className="max-w-5xl mx-auto px-4 py-6 space-y-4">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-extrabold uppercase tracking-[0.14em] text-gray-600">
          <Chip icon={ShieldCheck} label="Licensed & Insured" />
          <Chip icon={Star}        label="5.0 · Google Reviews" />
          <Chip icon={Lock}        label="SSL Secure Checkout" />
          <Chip icon={CheckCircle2} label="500+ Jobs Completed" />
          <Chip icon={CheckCircle2} label="Since 2018" />
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[12px] text-gray-600">
          <a href="tel:9048328730" className="inline-flex items-center gap-1 hover:text-[#047857] font-bold" data-testid="trust-phone">
            <Phone className="w-3.5 h-3.5" /> (904) 832-8730
          </a>
          <a href="mailto:jdsnlawncare@gmail.com" className="inline-flex items-center gap-1 hover:text-[#047857] font-bold" data-testid="trust-email">
            <Mail className="w-3.5 h-3.5" /> jdsnlawncare@gmail.com
          </a>
        </div>
        <p className="text-center text-[11.5px] text-gray-500 leading-relaxed max-w-2xl mx-auto" data-testid="trust-portal-blurb">
          The customer portal is provided to securely manage your
          appointments, estimates, invoices, payments, and communication
          with JDSN Lawn Care. Your information is protected and will never
          be shared.
        </p>
      </div>
    </section>
  );
}

function Chip({ icon: Icon, label }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] font-extrabold text-gray-700">
      <Icon className="w-3.5 h-3.5 text-[#047857]" /> {label}
    </span>
  );
}
